/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAdminPermissions } from '../fn/permissions/get-admin-permissions';
import { GetAdminPermissions$Params } from '../fn/permissions/get-admin-permissions';
import { getAllPermissions } from '../fn/permissions/get-all-permissions';
import { GetAllPermissions$Params } from '../fn/permissions/get-all-permissions';
import { GetAllPermissionsResponse } from '../models/get-all-permissions-response';
import { GetAllRolesAndPermissionsResponse } from '../models/get-all-roles-and-permissions-response';
import { getPermissions } from '../fn/permissions/get-permissions';
import { GetPermissions$Params } from '../fn/permissions/get-permissions';
import { getPermissionsByAppId } from '../fn/permissions/get-permissions-by-app-id';
import { GetPermissionsByAppId$Params } from '../fn/permissions/get-permissions-by-app-id';
import { getRolesBasedOnLoggedUserRole } from '../fn/permissions/get-roles-based-on-logged-user-role';
import { GetRolesBasedOnLoggedUserRole$Params } from '../fn/permissions/get-roles-based-on-logged-user-role';
import { updatePermission } from '../fn/permissions/update-permission';
import { UpdatePermission$Params } from '../fn/permissions/update-permission';

@Injectable({ providedIn: 'root' })
export class PermissionsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPermissions()` */
  static readonly GetPermissionsPath = '/api/v2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissions$Response(params?: GetPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissions(params?: GetPermissions$Params, context?: HttpContext): Observable<void> {
    return this.getPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updatePermission()` */
  static readonly UpdatePermissionPath = '/api/v2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePermission()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePermission$Response(params: UpdatePermission$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePermission(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePermission$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePermission(params: UpdatePermission$Params, context?: HttpContext): Observable<void> {
    return this.updatePermission$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAdminPermissions()` */
  static readonly GetAdminPermissionsPath = '/api/v1/adminportal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdminPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdminPermissions$Response(params?: GetAdminPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getAdminPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdminPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdminPermissions(params?: GetAdminPermissions$Params, context?: HttpContext): Observable<void> {
    return this.getAdminPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getRolesBasedOnLoggedUserRole()` */
  static readonly GetRolesBasedOnLoggedUserRolePath = '/api/v2/role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRolesBasedOnLoggedUserRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRolesBasedOnLoggedUserRole$Response(params?: GetRolesBasedOnLoggedUserRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getRolesBasedOnLoggedUserRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRolesBasedOnLoggedUserRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRolesBasedOnLoggedUserRole(params?: GetRolesBasedOnLoggedUserRole$Params, context?: HttpContext): Observable<void> {
    return this.getRolesBasedOnLoggedUserRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPermissionsByAppId()` */
  static readonly GetPermissionsByAppIdPath = '/api/v2/{applicationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPermissionsByAppId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissionsByAppId$Response(params: GetPermissionsByAppId$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllRolesAndPermissionsResponse>> {
    return getPermissionsByAppId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPermissionsByAppId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissionsByAppId(params: GetPermissionsByAppId$Params, context?: HttpContext): Observable<GetAllRolesAndPermissionsResponse> {
    return this.getPermissionsByAppId$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllRolesAndPermissionsResponse>): GetAllRolesAndPermissionsResponse => r.body)
    );
  }

  /** Path part for operation `getAllPermissions()` */
  static readonly GetAllPermissionsPath = '/api/v2/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPermissions$Response(params?: GetAllPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllPermissionsResponse>> {
    return getAllPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPermissions(params?: GetAllPermissions$Params, context?: HttpContext): Observable<GetAllPermissionsResponse> {
    return this.getAllPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllPermissionsResponse>): GetAllPermissionsResponse => r.body)
    );
  }

}
